var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('modelo-impressao-form'),_c('b-modal',{attrs:{"id":"modal-form","hide-footer":"","title":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }